// BLE lamp node (DeviceID 100) on the phone — a parent or a group.
//
// The screen itself is SHARED with the desktop since 2026-10-11:
// ui/shared/ble/BleNodePanel.jsx. The phone adds only its own header bar
// (rename, ⋮ menu); everything below it is the panel.

import React from 'react';
import DeviceAppBar from './components/DeviceAppBar';
import BleNodePanel from '../../../shared/ble/BleNodePanel';

export default function BleNodeScreen({ device }) {
  return (
    <BleNodePanel
      device={device}
      renderHeader={(ctl) => (ctl
        ? <DeviceAppBar device={device} onRenamed={(name) => ctl.rename(ctl.node, name)} />
        : <DeviceAppBar device={device} />)}
    />
  );
}
